import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clearBuffer } from '../../actions/buffer';

const initialState = null as CreditCardPaymentInformation | null;

const slice = createSlice({
  name: '$bufferCreditCardPaymentInformation',
  initialState,
  reducers: {
    setBufferCreditCardPaymentInformation(
      state,
      action: PayloadAction<CreditCardPaymentInformation | null>,
    ) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(clearBuffer, (state, action) => {
      return initialState;
    });
  },
});

export const { setBufferCreditCardPaymentInformation } = slice.actions;
export default slice.reducer;
